<template>
  <v-container fluid class="pa-0">

    <section-header :fontsize="'h2'" :icon="'$job'" :title="$t('servicesystem.common_objects.job.job_details')"
      :leftpad="'ml-4'">
    </section-header>

    <v-card :key="detailsResetKey" v-if="editObject" v-click-outside="unfocusEntireCard">
      <slotted-card :editable="hideLockOrShowEdit"
        :title="editObject && editObject.DisplayName ? editObject.DisplayName : $t('servicesystem.common_objects.fallbackterms.no_job_name')"
        :icon="'$job'" :fontsize="'h3'" :externalEditTrigger="edittrigger" @editMode="setEditMode" @valid="setValid">
        <template v-slot:content>
          <v-container class="pa-0" :class="isNew ? 'pb-3' : ''" fluid>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pa-0" :class="!isPhoneBool ? 'pb-3' : ''">

                <QAutoComplete v-model="editObject.JobTypeId" :label="$t('servicesystem.common_objects.job.type')"
                  :list="typeList" :textkey="'Name'" :valuekey="'Id'" :rules="[requiredRule]"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++" class="mx-3">

                  <template v-slot:item="{ item }">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        {{ item.Name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon v-if="jobtypeInfoTip[item.Id]" class="ml-2 my-auto mr-n2">
                      <QInfo :text="jobtypeInfoTip[item.Id]">
                      </QInfo>
                    </v-list-item-icon>
                  </template>

                  <!-- 
                  <template v-slot:append-outer v-if="jobtypeInfoTip[editObject.JobTypeId]">
                    <QInfo :text="jobtypeInfoTip[editObject.JobTypeId]" class="mt-1">
                    </QInfo>
                  </template>
                  -->
                </QAutoComplete>
                <QAutoComplete v-model="editObject.JobPriorityId"
                  :label="$t('servicesystem.common_objects.job.priority')" :list="priorityList" :textkey="'Name'"
                  :valuekey="'Id'" :rules="[requiredRule]" :externaledit="isNew || editMode"
                  @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QAutoComplete>
                <QTextField v-model="editObject.EstimatedTime"
                  :label="$t('servicesystem.common_objects.job.time_estimate')" :externaledit="isNew || editMode"
                  :rules="[requiredRule, floatRule]" @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QTextField>
              </v-col>

              <v-divider v-if="!isPhoneBool" vertical />

              <v-col cols="12" sm="4" class="pa-0" :class="!isPhoneBool ? 'pb-3' : ''">
                <QAutoComplete v-model="editObject.JobStatusId" :label="$t('servicesystem.common_objects.job.status')"
                  :list="statuses" :textkey="'Name'" :valuekey="'Id'" :rules="[requiredRule]"
                  :disabled="isApproved || isInvalidStatus" :externaledit="!isInvalidStatus && (isNew || editMode)"
                  @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QAutoComplete>
                <QAutoComplete v-model="editObject.JobSubStatusId"
                  :label="$t('servicesystem.common_objects.job.substatus')" :disabled="!showSubstatus"
                  :style="showSubstatus || 'opacity: 0 !important;'" :list="substatuses" :textkey="'Name'"
                  :valuekey="'Id'" clearable :externaledit="isNew || editMode"
                  @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QAutoComplete>
                <QTextField v-if="!isNew && FieldMapping && FieldMapping.Order && FieldMapping.Order.InvoiceReference4"
                  v-model="editObject.InvoiceReference4" :label="FieldMapping.Order.InvoiceReference4.DisplayName"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QTextField>
              </v-col>

              <v-divider v-if="!isPhoneBool" vertical />

              <v-col cols="12" sm="4" class="pa-0" :class="!isPhoneBool ? 'pb-3' : ''">
                <!--
                <QSwitchInput v-model="editObject.NoInvoice" :label="$t('servicesystem.common_objects.job.notbillable')"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QSwitchInput>
                -->
                <QTextField v-model="editObject.InvoiceReference"
                  :label="(FieldMapping.Order && FieldMapping.Order.InvoiceReference && FieldMapping.Order.InvoiceReference.DisplayName)
                    ? FieldMapping.Order.InvoiceReference.DisplayName : $t('servicesystem.common_objects.job.order_refrence')" :externaledit="isNew || editMode"
                  @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QTextField>
                <QTextField v-if="FieldMapping && FieldMapping.Order && FieldMapping.Order.InvoiceReference2"
                  v-model="editObject.InvoiceReference2" :label="FieldMapping.Order.InvoiceReference2.DisplayName"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QTextField>
                <QTextField v-if="FieldMapping && FieldMapping.Order && FieldMapping.Order.InvoiceReference3"
                  v-model="editObject.InvoiceReference3" :label="FieldMapping.Order.InvoiceReference3.DisplayName"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++" class="mx-3">
                </QTextField>
              </v-col>
            </v-row>

            <v-divider v-if="!isPhoneBool" />

            <v-row no-gutters>
              <v-col :cols="(editObject.FirstLineComment || editObject.ServiceManagerComment) || isPhoneBool ? 12 : 6"
                class="px-3" style="background-color: #fffbf0;">
                <QTextArea v-model="editObject.FirstLineComment"
                  :label="$t('servicesystem.common_objects.job.first_line_comment')" :backgroundcolor="'#fffbf0'"
                  :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampFirstLineComment"
                  :singleline="!editObject.FirstLineComment"
                  :placeholder="!editObject.FirstLineComment ? $t('servicesystem.common_objects.job.first_line_comment') : undefined"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++">
                </QTextArea>
              </v-col>
              <v-col :cols="(editObject.FirstLineComment || editObject.ServiceManagerComment) || isPhoneBool ? 12 : 6"
                class="px-3" style="background-color: #fff2ea;">
                <QTextArea v-model="editObject.ServiceManagerComment"
                  :label="$t('servicesystem.common_objects.job.service_manager_comment')" :backgroundcolor="'#fff2ea'"
                  :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampServiceManagerComment"
                  :singleline="!editObject.ServiceManagerComment"
                  :placeholder="!editObject.ServiceManagerComment ? $t('servicesystem.common_objects.job.service_manager_comment') : undefined"
                  :externaledit="isNew || editMode" @FocusState="editMode ? null : edittrigger++">
                </QTextArea>
              </v-col>
            </v-row>

            <v-divider />

            <v-row no-gutters v-if="!isNew">
              <v-col cols="auto" class="mx-3">
                <QTextField :value="i18nFormatDateTime(editObject.CreatedDate)"
                  :label="$t('servicesystem.common_objects.job.created')" disabled>
                </QTextField>
              </v-col>
              <v-col cols="auto" class="mr-3">
                <QTextField :value="editObject.CreatedBy" :label="$t('servicesystem.common_objects.job.creator')"
                  disabled>
                </QTextField>
              </v-col>
            </v-row>

            <edit-bar v-if="!isNew && editMode" :externalTrigger="editMode" :saveable="valid && IsChanged"
              @saveEmit="handleSave" @modeEmit="edittrigger++" class="mt-2">
            </edit-bar>
          </v-container>
        </template>
      </slotted-card>
    </v-card>
  </v-container>
</template>


<script>
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "JobCard",
  props: {
    isNew: Boolean,
  },
  components: {
    SectionHeader,
    SlottedCard,
    EditBar,
  },

  data() {
    return {
      valid: false,
      editObject: null,
      copyObject: null,
      edittrigger: 0,
      editMode: false,
      detailsResetKey: 1,
      jobtypeInfoTip: {
        '4': this.$t('servicesystem.common_objects.job_type.parts_hint'),
        '3': this.$t('servicesystem.common_objects.job_type.support_hint'),
        '2': this.$t('servicesystem.common_objects.job_type.pm_hint'),
      }
    };
  },

  mounted() {

    setTimeout(() => {
      this.SetDetails();

    }, 200);

  },

  methods: {
    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    handleSave() {
      this.edittrigger++;
      this.$store.dispatch("JobHub/JobParentjob/setNewJobDetails", this.editObject);
      this.$store
        .dispatch("JobHub/JobParentjob/saveJobDetails")
        .then((response) => {
          this.editObject.JobSubStatusId = response.JobSubStatusId;
          this.$store.dispatch("JobHub/JobParentjob/setJobDetails", response);
          this.$store.dispatch("BackgroundUpdater/Checker", "StatusMap");
        })
        .catch((response) => {
          this.$store.dispatch("ErrorStore/add", response); //.log(response);
        });
    },

    findSelectValue(list, inVal) {
      return list[list.findIndex((x) => x.Id === inVal)];
    },

    SetDetails(backgroundUpdate) {

      if (this.CustomerLoading || !this.Customer && !this.JobDetails) {
        return;
      }

      var defaultobj = Object.assign({}, this.defaultJobDetails);
      var existingcopy = Object.assign({}, this.JobDetails);

      var reducedcopy = {
        Id: existingcopy.Id,
        DisplayName: existingcopy.DisplayName,
        JobTypeId: existingcopy.JobTypeId,
        JobPriorityId: existingcopy.JobPriorityId,
        EstimatedTime: existingcopy.EstimatedTime,
        JobStatusId: existingcopy.JobStatusId,
        JobSubStatusId: existingcopy.JobSubStatusId,
        NoInvoice: existingcopy.NoInvoice,
        InvoiceReference: existingcopy.InvoiceReference,
        InvoiceReference2: existingcopy.InvoiceReference2,
        InvoiceReference3: existingcopy.InvoiceReference3,
        InvoiceReference4: existingcopy.InvoiceReference4,
        FirstLineComment: existingcopy.FirstLineComment,
        ServiceManagerComment: existingcopy.ServiceManagerComment,
        CreatedDate: existingcopy.CreatedDate,
        CreatedBy: existingcopy.CreatedBy,
      };

      var obj = this.JobDetails && !!Object.keys(this.JobDetails).length ? reducedcopy : defaultobj;

      this.editObject = Object.assign({}, obj);
      this.copyObject = Object.assign({}, obj);
      if (!backgroundUpdate) {
        this.detailsResetKey++;
      }

    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.edittrigger++;
      }
    },

    composeDefaultFirstLineComment() {
      var text = "";
      if (this.globalSettings.SetFirstLineCommentFromCustomerNote) {
        var cus = this.Customer;
        var parent = cus?.ParentCustomer;
        if (parent?.Comments?.length) {
          text += `${parent.Name}: ${parent.Comments}\n\n`;
        }
        if (cus?.Comments?.length) {
          text += `${cus.Name}: ${cus.Comments}\n`;
        }
      }

      return text;
    }
  },

  computed: {
    defaultJobDetails() {
      var defaultobj = {
        Id: null,
        JobTypeId: this.globalSettings.DefaultJobTypeId ?? 1, 
        JobPriorityId: this.globalSettings.DefaultJobPriorityId ?? 3,
        EstimatedTime: this.globalSettings.DefaultJobEstimatedTime ?? 2, 
        JobStatusId: this.globalSettings.DefaultJobStatusId ?? 10,
        JobSubStatusId: null,
        NoInvoice: false,
        InvoiceReference: "",
        InvoiceReference2: "",
        InvoiceReference3: "",
        InvoiceReference4: "",
        ServiceManagerComment: "",
        FirstLineComment: this.composeDefaultFirstLineComment(),
        CreatedDate: null,
        CreatedBy: null,
      };
      return defaultobj;
    },

    JobDetails() {
      return this.$store.getters["JobHub/JobParentjob/JobDetails"];
    },

    priorityList() {
      var list = this.$store.getters["LookUpStore/JobPriorityList"];
      return list && list.length ? list : [];
    },

    typeList() {
      var list = this.$store.getters["LookUpStore/JobTypeList"];
      return list && list.length ? list : [];
    },

    Customer() {
      var customer = this.$store.getters["JobHub/JobCustomer/Customer"];
      return customer;
    },

    isApproved() {
      return this.JobDetails && this.JobDetails.JobStatusId && this.JobDetails.JobStatusId === 70 ? true : false;
    },

    statuses() {
      var statuses = Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
      var filteredstatuses = statuses.filter((y) => y.Id < 100);
      var bool = this.isApproved;
      filteredstatuses = filteredstatuses.filter(function (x) {
        return bool ? x.Id === 70 : x.Id != 70; //logic to only include job completed or exclude it so that the user cant change to or from it usig the dropdown
      });
      if (this.isInvalidStatus) {
        var invalidstatus = Object.assign({}, this.JobDetails.JobStatus);
        invalidstatus.IsActive = false;
        filteredstatuses.unshift(invalidstatus);
      }

      return filteredstatuses;
    },

    substatuses() {
      var list = this.$store.getters["LookUpStore/JobSubStatusListByParent"](this.editObject.JobStatusId);
      return list ? list : [];
    },

    showSubstatus() {
      //console.log(this.substatuses?.length, !this.isInvalidStatus)
      return !!(this.substatuses?.length && !this.isInvalidStatus)
    },

    hideLockOrShowEdit() {
      if (!this.isNew && this.checkPermission("Actions", "editJobDetails")) {
        //if viewing existing job and have permission to edit = show pencil
        return true;
      } else if (this.isNew && this.checkPermission("Actions", "createJob")) {
        //if making new job and has permission to create = just hide the pencil
        return "hide";
      } else {
        //Else, if you dont have permissions = lock icon
        return false;
      }
    },

    isInvalidStatus() {
      var retval;
      var oldjob = this.$store.getters["JobHub/JobParentjob/JobDetails"];
      if (!oldjob || !oldjob.JobStatusId || oldjob.JobStatusId < 70) {
        retval = false;
      } else {
        retval = true;
      }
      return retval;
    },

    IsChanged() {
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    }
  },

  watch: {
    JobDetails: function () {

      this.SetDetails(true);
    },

    editMode: function (newVal) {
      if (!newVal) {

        this.SetDetails();
      }
    },

    Customer: function () {

      this.SetDetails();
    },

    CustomerLoading() {
      return this.$store.getters["JobHub/JobCustomer/CustomerLoading"];
    },

    editObject: {
      handler(newValue) {
        this.$store.dispatch("JobHub/JobParentjob/setNewJobDetails", newValue);
      },
      deep: true,
    }
  },
};
</script>